import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import AppHeader from "../components/AppHeader";
import ThirdWBS from "../components/ThirdWBS";
//import ThirdWBSRightPanel from "../components/ThirdWBSRightPanel";
//import NotationAccordionMatrixPanel from "../components/NotationAccordionMatrixPanel";
import NotationExcelSheet from "../components/NotationExcelSheet";
import MetricsAccordionTable from "../components/MetricsAccordionTable";

import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from "react-resizable-panels";

/* =========================================================
   MOBILE HOOK
========================================================= */

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < breakpoint
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [breakpoint]);

  return isMobile;
};

/* =========================================================
   COMPONENT
========================================================= */

const ThirdtabPanel = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const isMobile = useIsMobile();

  const [projectName, setProjectName] = useState(
    location.state?.projectName ||
      localStorage.getItem("projectName") ||
      ""
  );

  const userName = localStorage.getItem("userName");

  const [selectedActivityId, setSelectedActivityId] =
    useState<number | null>(null);

  const [selectedWbsId, setSelectedWbsId] =
    useState<number | null>(null);

  const [rightView, setRightView] = useState<
    "activity" | "wbs" | null
  >(null);

  const [activityLevel, setActivityLevel] = useState(1);

  const projectId = Number(id);

  /* =========================================================
     COMMON WBS COMPONENT
  ========================================================= */

  const wbsComponent = (
    <ThirdWBS
      projectId={projectId}
      projectName={projectName}
      activityLevel={activityLevel}
      onActivityClick={(activityId, wbsId) => {
        setSelectedActivityId(activityId);
        setSelectedWbsId(wbsId);
        setRightView("activity");
      }}
      onWbsClick={(wbsId) => {
        setSelectedActivityId(null);
        setSelectedWbsId(wbsId);
        setRightView("wbs");
      }}
    />
  );

  /* =========================================================
     COMMON LEFT PANEL CONTENT
  ========================================================= */

  const leftPanelContent = (
    <div
      className="flex h-full min-h-0 flex-col overflow-hidden"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      {/* HEADER */}
      <div
        className="flex shrink-0 items-center justify-between px-4 py-2"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <h2 className="flex items-center gap-2 text-indigo-700">
          Work Breakdown Structure
        </h2>

        <div className="flex items-center gap-2">
          <label className="text-gray-700">
            Level
          </label>

          <input
            type="number"
            min={0}
            value={activityLevel}
            onChange={(e) =>
              setActivityLevel(Number(e.target.value))
            }
            className="w-16 rounded border border-gray-300 px-2 py-1"
          />
        </div>
      </div>

      {/* WBS TREE */}
      <div className="flex-1 min-h-0 overflow-y-auto p-0 m-0">
        {wbsComponent}
      </div>
    </div>
  );

  return (
    <div
      className="flex h-screen flex-col bg-gray-100"
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      {/* =====================================================
          APP HEADER
      ===================================================== */}

      <AppHeader
        title={projectName || id || "Third Panel"}
        userName={userName}
        activeTab="third"

        onBack={() => navigate(-1)}

        onHome={() => navigate("/projects")}

        onDashboard={() =>
          navigate(`/project/${id}`, {
            state: { projectName },
          })
        }

        onSecond={() =>
          navigate(`/project/${id}/second`, {
            state: { projectName },
          })
        }

        onThird={() =>
          navigate(`/project/${id}/third`, {
            state: { projectName },
          })
        }

        onFourth={() =>
          navigate(`/project/${id}/fourth`, {
            state: { projectName },
          })
        }

        onFifth={() =>
          navigate(`/project/${id}/fifth`, {
            state: { projectName },
          })
        }

        onLogout={() => {
          sessionStorage.clear();
          localStorage.removeItem("token");
          navigate("/login");
        }}

        projectId={Number(id)}

        onProjectUpdated={(updatedName) => {
          setProjectName(updatedName);
        }}
      />

      {/* =====================================================
          MAIN CONTENT
      ===================================================== */}

      <div className="flex-1 min-h-0 overflow-hidden">

        {/* =================================================
            MOBILE VIEW
            ONLY LEFT WBS PANEL
        ================================================= */}

        {isMobile ? (
          <div className="h-full w-full overflow-hidden bg-white">
            {leftPanelContent}
          </div>
        ) : (

          /* ===============================================
             DESKTOP VIEW
             LEFT 25% + RIGHT 75%
          =============================================== */

          <PanelGroup
            direction="horizontal"
            autoSaveId="third-tab-layout"
            className="flex h-full min-h-0 overflow-hidden"
          >
            {/* LEFT PANEL */}
            <Panel defaultSize={25} minSize={15}>
              {leftPanelContent}
            </Panel>

            {/* RESIZE HANDLE */}
            {/* <PanelResizeHandle className="w-px bg-gray-500 cursor-col-resize flex-shrink-0" /> */}
            <PanelResizeHandle className="w-px shrink-0 bg-white border-0 cursor-col-resize" />

            {/* RIGHT PANEL */}
            <Panel defaultSize={75} minSize={25}>
              <div
                className="small-scrollbar flex h-full min-h-0 flex-1 overflow-y-auto"
                style={{ backgroundColor: "#FFFFFF" }}
              >
                {rightView === "activity" ? (
                  <MetricsAccordionTable
                    activityId={selectedActivityId}
                    wbsId={selectedWbsId}
                  />
                ) : (
                  <div className="flex h-full w-full items-center justify-center text-gray-500">
                    Select a WBS or Activity from the left panel.
                  </div>
                )}
              </div>
            </Panel>
          </PanelGroup>
        )}

      </div>
    </div>
  );
};

export default ThirdtabPanel;